import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);
import isMobile from '@/utils/isMobile'
export default new Vuex.Store({
  state: {
    isIOS: false,
    inGame: false,
    isM: isMobile(),
    device: isMobile() ? 'm' : 'm',//暂时没pc端
    region: process.env.VUE_APP_REGION || 'zl',//主体，用于区分图片资源的加载
    regionCdn: process.env.VUE_APP_CDN || 'https://media.zlongame.com/media/pictures/cn/vipCenter/',//主体资源cdn地址
    loginStatus: 0,//登录状态 0未登录 1已登录
    loadPop: false,//加载弹窗
    currentGameAppkey: localStorage.getItem('zlVipCurrentGameAppkey') || '1656417299063',//未登录时默认龙魂appkey
    wxProgram: false,//是否在微信小程序内
    codePop: false,//充值中心码弹窗
    accountInfo: {
      accId: '',
      availablePoints: 0,
      currentLevel: 1,
      v6Plus: false,//是否是V6+等级
      birthRemain: 0,//是否修改过生日
      levelExpire: "",
      phone: "",
      signDays: 0,
      validGrowth: 0,//当前成长值
      maxGrowth: 0,//最大成长值
      totalPoints: 0,//历史成长值
    },//用户信息
    gameList: [],//会员中心游戏列表 
  },
  mutations: {
    changeIsIOS(state, status) {
      state.isIOS = status
    },
    changeInGame(state, status) {
      state.inGame = status
    },
    changeCodePop(state, status) {
      state.codePop = status
    },
    changeWxProgram(state, status) {
      state.wxProgram = status
    },
    changeGameList(state, list) {
      state.gameList = list
    },
    // 更新单个字段的方法
    updateAccountField(state, { field, value }) {
      if (field == 'currentLevel' && value == 7) {
        state.accountInfo[field] = 6
        state.accountInfo.v6Plus = true
      } else {
        state.accountInfo[field] = value
        if (field == 'currentLevel' && value != 7) {
          state.accountInfo.v6Plus = false
        }
      }
    },
    changeAccountInfo(state, info) {
      if (info.currentLevel == 7) {//增加v6Plus字段
        info.v6Plus = true
        info.currentLevel = 6
      } else {
        info.v6Plus = false
      }
      state.accountInfo = info
    },
    changeCurrentGameAppkey(state, appkey) {
      state.currentGameAppkey = appkey
      localStorage.setItem('zlVipCurrentGameAppkey', appkey)
      let tracker = new Tracker({
        type: 'owsevent', // apevent-活动打点   owsevent-官网打点
        appkey: appkey, // 应用标识，用来区分埋点数据中的应用
        lpid: 'vipcenter_zlongame_cn',  // 页面唯一标识
        zone: 'cn', // cn-国内  tw-台湾 sg-新加坡 kr-韩国 us-欧美 jp-日本 sea-东南亚 vn-越南 埋点上报的后端接口
        enableTrackerKey: true,
        useClass: true, // 使用类名来标识domClick
        enableHeatMapTracker: false, // 是否开启热力图自动上报
        enableLoadTracker: true, // 是否开启页面加载自动上报，
        enableHistoryTracker: false, // 是否开启页面history变化自动上报
        enableHashTracker: false, // 是否开启页面hash变化自动上报
      })
      tracker.sendTracker("innerPageLoad")
    },
    changeLoadPop(state, status) {
      state.loadPop = status
    },
    changeLoginStatus(state, status) {
      state.loginStatus = status
    }
  },
  getters: {
    // 如果需要经常访问这些值，可以添加 getter 使用更方便
    availablePoints: state => state.accountInfo.availablePoints,
    currentLevel: state => state.accountInfo.currentLevel,
    v6Plus: state => state.accountInfo.v6Plus,
    birthRemain: state => state.accountInfo.birthRemain,
    validGrowth: state => state.accountInfo.validGrowth,
    maxGrowth: state => state.accountInfo.maxGrowth,
    signDays: state => state.accountInfo.signDays,
    totalPoints: state => state.accountInfo.totalPoints,
    // currentLevelStage: state => Math.ceil(state.accountInfo.currentLevel / 3),
    // // 每3个等级对应1个stage
    // // level 1-3 => stage 1
    // // level 4-6 => stage 2 
    // // level 7-9 => stage 3
    // // level 10-12 => stage 4
    // // level 13-15 => stage 5
    // // level 16-18 => stage 6
  },
  actions: {
  },
  modules: {
  }
})
